import { fetchGet, fetchPost } from "./helper";

const API_BASE = process.env.REACT_APP_API_DOMAIN;

export default class {
  // Core Data - used across the entire app
  static async getCoreData() {
    const response = await fetchGet(`${API_BASE}/core-data`);
    return response;
  }

  // Individual page data fetching methods
  static async getHomePage() {
    const response = await fetchGet(`${API_BASE}/home`);
    return response;
  }

  static async getRoomsPage() {
    const response = await fetchGet(`${API_BASE}/rooms`);
    return response;
  }

  static async getAmpRooms() {
    const response = await fetchGet(`${API_BASE}/amp-rooms`);
    return response;
  }

  static async getAboutPage() {
    const response = await fetchGet(`${API_BASE}/about`);
    return response;
  }

  static async getDiningPage() {
    const response = await fetchGet(`${API_BASE}/dining`);
    return response;
  }

  static async getThingsToDoPage() {
    const response = await fetchGet(`${API_BASE}/things-to-do`);
    return response;
  }

  static async getGettingHerePage() {
    const response = await fetchGet(`${API_BASE}/getting-here`);
    return response;
  }

  static async getPointsOfInterest() {
    const response = await fetchGet(`${API_BASE}/points-of-interest`);
    return response;
  }

  static async getPoliciesPage() {
    const response = await fetchGet(`${API_BASE}/policies`);
    return response;
  }

  static async getPressPage() {
    const response = await fetchGet(`${API_BASE}/press`);
    return response;
  }

  static async getGalleryPage() {
    const response = await fetchGet(`${API_BASE}/gallery`);
    return response;
  }

  static async getAmpPackages() {
    const response = await fetchGet(`${API_BASE}/amp-packages`);
    return response;
  }

  static async getAmpLMS() {
    const response = await fetchGet(`${API_BASE}/amp-lms`);
    return response;
  }

  static async getSpecialsPage() {
    const response = await fetchGet(`${API_BASE}/special`);
    return response;
  }

  // Instagram feed
  static async getInstagramFeed() {
    const { data } = await fetchGet(`${API_BASE}/instagram-feed`);
    return data || [];
  }

  // Contact form submission
  static sendContactUs(data, bookingType = "General") {
    const {
      firstName,
      lastName,
      emailAddress,
      cellPhone = "",
      city = "",
      groupName = "",
      dateDesired = "",
      numberOfRooms = 0,
      questions = "",
      isSubscribed = false,
      captchaResponse,
    } = data;

    const body = {
      firstName,
      lastName,
      emailAddress,
      cellPhone,
      city,
      groupName,
      dateDesired,
      numberOfRooms,
      questions,
      bookingType,
      isSubscribed,
      captchaResponse,
    };
    return fetchPost(`${API_BASE}/bespoke-contact-form/contacts`, body);
  }
}
